var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.formStructure !== undefined
      ? _c(
          "div",
          [
            _vm.formStructure.generateElements && _vm.formStructure.properties
              ? _c(
                  "div",
                  _vm._l(
                    _vm.formStructure.properties,
                    function (element, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _vm.formStructure.properties[index].autoGenerate
                            ? _c("q-element-generator", {
                                attrs: {
                                  element: _vm.formStructure.properties[index],
                                },
                                model: {
                                  value: _vm.model,
                                  callback: function ($$v) {
                                    _vm.model = $$v
                                  },
                                  expression: "model",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.formStructure.staticFormKey
              ? _c(
                  "div",
                  [
                    _c(_vm.formStructure.staticFormKey, {
                      tag: "component",
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "q-dialog",
              {
                attrs: {
                  title: this.$qt("model.deleteDialog.title"),
                  width: "70%",
                  visible: _vm.formDesignerDialogVisible,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.formDesignerDialogVisible = $event
                  },
                },
              },
              [
                _c("q-form-designer", {
                  model: {
                    value: _vm.formStructure.properties,
                    callback: function ($$v) {
                      _vm.$set(_vm.formStructure, "properties", $$v)
                    },
                    expression: "formStructure.properties",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c("q-button", { attrs: { type: "primary" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$qt("model.deleteDialog.confirm")) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "q-button",
                      {
                        attrs: { type: "inverse" },
                        on: {
                          click: function ($event) {
                            _vm.formDesignerDialogVisible = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$qt("model.deleteDialog.cancel")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", [_c("h2", [_vm._v("Form structure is null")])]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }